import { useSelector } from "react-redux";

// Selectors
import * as userSelectors from "redux/user/selectors";
import { useCatalogsStore } from "stores/catalogs";

// Types
import { CurrencySignPositionEnum, CurrencyType } from "types/Currency";

const useFormatNumber = () => {
  const currencies = useCatalogsStore((state) => state.currencies);
  const currency = useSelector(userSelectors.currency);

  return (
    number: number,
    // eslint-disable-next-line default-param-last
    precision: number = 0,
    isCurrency?: boolean,
    currencyCode?: string | number,
    divideBy100?: boolean,
  ) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(number)) {
      const selectedCurrency: CurrencyType | null =
        currencies?.find((cur) =>
          currencyCode
            ? cur.id === currencyCode
            : cur.isoCode === currency?.isoCode,
        ) || null;

      if (isCurrency && selectedCurrency) {
        if (selectedCurrency.signPosition === CurrencySignPositionEnum.AFTER) {
          return `0 ${selectedCurrency.sign}`;
        }
        if (selectedCurrency.signPosition === CurrencySignPositionEnum.BEFORE) {
          return `${selectedCurrency.sign} 0`;
        }
      }
      return "0";
    }

    const formattedNumber = divideBy100 ? number / 100 : number;

    const hasFractionalPart = formattedNumber % 1 !== 0;
    const finalPrecision = hasFractionalPart ? precision : 0;

    const option = {
      minimumFractionDigits: finalPrecision,
      maximumFractionDigits: finalPrecision,
    };

    const formattedString = new Intl.NumberFormat("ru-RU", option).format(
      formattedNumber,
    );

    if (isCurrency) {
      const selectedCurrency: CurrencyType | null =
        currencies?.find((cur) =>
          currencyCode
            ? cur.id === currencyCode
            : cur.isoCode === currency?.isoCode,
        ) || null;

      if (selectedCurrency) {
        if (selectedCurrency.signPosition === CurrencySignPositionEnum.AFTER) {
          return `${formattedString} ${selectedCurrency.sign}`;
        }
        if (selectedCurrency.signPosition === CurrencySignPositionEnum.BEFORE) {
          return `${selectedCurrency.sign} ${formattedString}`;
        }
      }
    }

    return formattedString;
  };
};

export default useFormatNumber;
